import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { FiLogOut } from "react-icons/fi";

const LogoutModal = ({ show, onCancel, onConfirm }) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [show]);

  if (!show) return null;

  return ReactDOM.createPortal(
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backdropFilter: "blur(2px)",
      }}
    >
      <div
        style={{
          background: "#fff",
          width: "90%",
          maxWidth: "400px",
          padding: "2rem",
          borderRadius: "1rem",
          boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.3)",
          textAlign: "center",
        }}
      >
        <div
          style={{
            background: "#f2edfd",
            width: "3.5rem",
            height: "3.5rem",
            margin: "0 auto 1rem",
            borderRadius: "0.75rem",
            fontSize: "1.8rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#925fe2",
          }}
        >
          <FiLogOut />
        </div>
        <p
          style={{
            fontSize: "1.2rem",
            fontWeight: 500,
            marginBottom: "2rem",
            color: "#333",
          }}
        >
          Are you sure you want to logout?
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "1rem",
          }}
        >
          <button
            onClick={onCancel}
            style={{
              padding: "0.6rem 1.5rem",
              border: "none",
              fontSize: "1rem",
              borderRadius: "0.5rem",
              cursor: "pointer",
              backgroundColor: "#f3f3f3",
              color: "#333",
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: "0.6rem 1.5rem",
              border: "none",
              fontSize: "1rem",
              borderRadius: "0.5rem",
              cursor: "pointer",
              backgroundColor: "#7f56d9",
              color: "#fff",
            }}
          >
            Logout
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LogoutModal;
